import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../../util/axios";
const JixiaoList = styled.div`
  .month {
    backgroundcolor: #fff;
  }
  .month ul {
    list-style: none;
    padding: 10px 20px 10px 20px;
    margin: 0;
  }
  .month li {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    width: 100%;
    padding: 0 10px 0 10px;
    margin-bottom: 10px;
  }
  .month p {
    display: flex;
    justify-content: space-between;
  }
`;
interface Array1 {
  publicAffair: string;
  beTestedStaffDepartmentCode: string;
  beTestedStaffCode: string;
  vSheetId: string;
  uuid: string;
  beTestedStaffPositionCode: string;
  workPerformance: string;
}
export default function StaffAssessment() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const tabs = [{ title: "未考核" }, { title: "已考核" }];
  const [staffList, setStaffList] = useState<Array1[]>([]);
  const [staff1List, setStaff1List] = useState<Array1[]>([]);
  const [judgeList, setJudgeList] = useState<Array1[]>([]);
  const [judge1List, setJudge1List] = useState<Array1[]>([]);
  const [keyword, setKeyword] = useState<string>();
  const [keyword1, setKeyword1] = useState<string>();
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    console.log(tstr);
    instance
      .post(
        `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffSome&vSheetId=` +
          tstr
      )
      .then((resp) => {
        // console.log(resp.data.Data.data)
        // console.log(resp)
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffElse&vSheetId=` +
                tstr
            )
            .then((resp) => {
              // console.log(resp.data.Data.data)
              // console.log(resp)
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                // console.log(arr)
                setStaffList(arr);
                setStaff1List(arr);
                let newArr = arr.filter((item: any, index: any) => {
                  return !item.publicAffair;
                });
                let newArr1 = arr.filter((item: any, index: any) => {
                  return item.publicAffair;
                });
                setJudgeList(newArr);
                setJudge1List(newArr1);
                // console.log(newArr);
              }
            });
        }
      });
  }, []);
  //搜索未考核
  const searchBarChange = useCallback((keyword) => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    console.log(tstr);
    instance
      .post(
        `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffSome&vSheetId=` +
          tstr +
          "&mobileParam=" +
          keyword
      )
      .then((resp) => {
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffElse&vSheetId=` +
                tstr +
                "&mobileParam=" +
                keyword
            )
            .then((resp) => {
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                setStaffList(arr);
              }
            });
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    let url = window.location.href; //获取请求进来的完整url
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    console.log(tstr);
    instance
      .post(
        `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffSome&vSheetId=` +
          tstr
      )
      .then((resp) => {
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffElse&vSheetId=` +
                tstr
            )
            .then((resp) => {
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                setStaffList(arr);
              }
            });
        }
      });
  }, []);
  const searchBarChange1 = useCallback((keyword1) => {
    let url = window.location.href;
    let tstr = url.substring(url.indexOf("=") + 1);
    console.log(tstr);
    instance
      .post(
        `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffSome&vSheetId=` +
          tstr +
          "&mobileParam=" +
          keyword1
      )
      .then((resp) => {
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffElse&vSheetId=` +
                tstr +
                "&mobileParam=" +
                keyword1
            )
            .then((resp) => {
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                setStaff1List(arr);
              }
            });
        }
      });
  }, []);
  const noSearch1 = useCallback(() => {
    let url = window.location.href; //获取请求进来的完整url
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    console.log(tstr);
    instance
      .post(
        `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffSome&vSheetId=` +
          tstr
      )
      .then((resp) => {
        if (resp.data.Status == 1) {
          let arr1 = resp.data.Data.data;
          instance
            .post(
              `/oa/examYear/getExecuteYearStaffList?permissionType=staffMe&type=staffElse&vSheetId=` +
                tstr
            )
            .then((resp) => {
              if (resp.data.Status == 1) {
                let arr2 = resp.data.Data.data;
                let arr = arr1.concat(arr2);
                setStaff1List(arr);
              }
            });
        }
      });
  }, []);
  //搜索已考核
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(
                  //     `/hr/jxassessment/yearassessment`
                  // );
                  history.go(-1);
                }}
              />
            }
          >
            员工绩效考核
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 未考核 */}
            <div className="month">
              <SearchBar
                value={keyword}
                onChange={(value) => setKeyword(value)}
                placeholder="请输入被考核人姓名"
                className="margin"
                onSubmit={() => {
                  searchBarChange(keyword);
                }}
                onCancel={() => {
                  noSearch();
                }}
              />
              <ul>
                {staffList.map((item) =>
                  !item.publicAffair ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/jxassessment/yearassessment/staff/details?vSheetId=" +
                          item.vSheetId +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>
                          {item.beTestedStaffDepartmentCode.substring(
                            0,
                            item.beTestedStaffDepartmentCode.indexOf("c")
                          )}
                        </span>
                        <span>
                          {item.beTestedStaffCode.substring(
                            0,
                            item.beTestedStaffCode.indexOf("c")
                          )}
                        </span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
              {(judgeList.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <span>暂无更多数据</span>
                </div>
              )) ||
                (staffList.length === 0 && (
                  <div style={{ textAlign: "center", marginTop: 10 }}>
                    <span>暂无更多数据</span>
                  </div>
                ))}
            </div>
            {/* 已考核 */}
            <div className="month">
              <SearchBar
                value={keyword1}
                onChange={(value) => setKeyword1(value)}
                placeholder="请输入被考核人姓名"
                className="margin"
                onSubmit={() => {
                  searchBarChange1(keyword1);
                }}
                onCancel={() => {
                  noSearch1();
                }}
              />
              <ul>
                {staff1List.map((item) =>
                  item.publicAffair ? (
                    <li
                      onClick={() => {
                        window.location.href =
                          "/hr/jxassessment/yearassessment/staff/details?vSheetId=" +
                          item.vSheetId +
                          "&" +
                          encodeURI(item.uuid);
                      }}
                    >
                      <p>
                        <span>
                          {item.beTestedStaffDepartmentCode.substring(
                            0,
                            item.beTestedStaffDepartmentCode.indexOf("c")
                          )}
                        </span>
                        <span>
                          {item.beTestedStaffCode.substring(
                            0,
                            item.beTestedStaffCode.indexOf("c")
                          )}
                        </span>
                      </p>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
              {(judge1List.length === 0 && (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                  <span>暂无更多数据</span>
                </div>
              )) ||
                (staff1List.length === 0 && (
                  <div style={{ textAlign: "center", marginTop: 10 }}>
                    <span>暂无更多数据</span>
                  </div>
                ))}
            </div>
          </Tabs>
        </div>
      </JixiaoList>
    </>
  );
}
